import React from 'react';
import { MoonIcon, SunIcon } from 'lucide-react';
import { useAdminTheme } from '../../../hooks/useAdminTheme';
export function ThemeToggle() {
  const {
    theme,
    toggle
  } = useAdminTheme();
  const isDark = theme === 'dark';
  const label = isDark ? 'Skift til lys tilstand' : 'Skift til mørk tilstand';
  return <button type="button" onClick={toggle} aria-label={label} title={label} className="inline-flex h-10 w-10 items-center justify-center rounded-xl text-ink-soft transition-colors duration-150 ease-smooth hover:bg-white hover:text-accent" data-id="element-615" data-mp="w5ijn0tcwo9n">
      {isDark ? <SunIcon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" data-id="element-616" data-mp="i5zemgvudt1k" /> : <MoonIcon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" data-id="element-617" data-mp="d87nvq6xocyy" />}
    </button>;
}